import { ShieldAlert } from "lucide-react";

export default function ForbiddenPage() {
  return (
    <div className="mx-auto flex min-h-[40vh] max-w-lg flex-col items-center justify-center px-4 text-center">
      <ShieldAlert
        className="mb-3 h-8 w-8 text-muted"
        strokeWidth={1.75}
        aria-hidden
      />
      <h1 className="text-lg font-semibold text-foreground">No access</h1>
      <p className="mt-2 text-sm text-foreground-secondary">
        Your role does not include this page. Ask someone with User Roles access
        to tick the right for your role.
      </p>
    </div>
  );
}
